export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetSaveGame(context) {
      context.commit("updateSaveGame", false)
    },
  },
  mutations: {
    updateSaveGame(state, data) {
      return state.data = data
    }
  }
}